import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {
  requestOptions,
  VIPSDataServiceURL,
} from "../../Constants/GlobalConstant";
import { sessionCache } from "../../CommonFuntion/sessionCache";

const AutocompleteComponent = (props) => {
  const { divisionId, onOptionSelect, isRequired, userId, searchParams } =
    props;
  const [selectedValue, setSelectedValue] = useState(null);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const fetchDataFromAPI = async (searchQuery) => {
    try {
      const response = await fetch(
        `${VIPSDataServiceURL}` +
          `/Customer/SearchCustomerAccount?divisionID=${divisionId}&` +
          `customerSearch=${searchQuery}`,
        requestOptions
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  useEffect(() => {
    let firstPageID= JSON.parse(localStorage.getItem("firstPageID"))!==null? JSON.parse(localStorage.getItem("firstPageID")): searchParams.get("PageID");
    const data = sessionCache.get(userId + firstPageID + "autocomplete");
    if (data) {
      setSelectedValue(data["invoiceAddress"]);
      onOptionSelect(data["invoiceAddress"]);
    }
    if (inputValue.length >= 3) {
      fetchDataFromAPI(inputValue).then((data) => {
        setOptions(data);
      });
    } else {
      //setOptions([]);
    }
  }, [inputValue]);
  const handleOptionChange = (event, invoiceAddress) => {
    setSelectedValue(invoiceAddress);
    setInputValue(invoiceAddress ? invoiceAddress.customer_id.trim() : "");
    onOptionSelect(invoiceAddress);
    let data = {
      invoiceAddress,
    };
 let firstPageID= JSON.parse(localStorage.getItem("firstPageID"))!==null? JSON.parse(localStorage.getItem("firstPageID")): searchParams.get("PageID");
    sessionCache.set(userId + firstPageID + "autocomplete", data);
  };
  useEffect(() => {
    if (
      selectedValue &&
      !options.some(
        (option) =>
          option.customer_id.trim() === selectedValue.customer_id.trim()
      )
    ) {
      setSelectedValue(null);
    }
  }, []);

  return (
    <div className="autocomplete-wrapper">
      <Autocomplete
        variant="standard"
        value={selectedValue}
        onChange={handleOptionChange}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue.trim());
        }}
        options={options}
        getOptionLabel={(option) =>
          option.customer_id.trim() + "(" + option.customer_name.trim() + ")"
        }
        renderInput={(params) => (
          <TextField
            variant="standard"
            {...params}
            label="Search Customer"
            error={isRequired && !selectedValue}
            helperText={
              isRequired && !selectedValue ? "This field is required." : ""
            }
          />
        )}
        isOptionEqualToValue={(option, value) =>
          option.customer_id.trim() === value.customer_id.trim()
        }
      />
    </div>
  );
};

export default AutocompleteComponent;
